import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const ExtentIcon = withSvgIcon(
    <g>
        <path d="M120.4 0H0v121.5h24.9v-79l156.6 156.6 17.6-17.6L42.5 24.9h77.9zM500 120.4V0H378.5v24.9h79L300.9 181.5l17.6 17.6L475.1 42.5v77.9zM379.6 500H500V378.5h-24.9v79L318.5 300.9l-17.6 17.6 156.6 156.6h-77.9zM0 379.6V500h121.5v-24.9h-79l156.6-156.6-17.6-17.6L24.9 457.5v-77.9z" />
    </g>
);
